/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateJournalSupportRequest
 */
export interface UpdateJournalSupportRequest {
    /**
     * 
     * @type {Date}
     * @memberof UpdateJournalSupportRequest
     */
    endTimeUtc: Date;
}

/**
 * Check if a given object implements the UpdateJournalSupportRequest interface.
 */
export function instanceOfUpdateJournalSupportRequest(value: object): value is UpdateJournalSupportRequest {
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    return true;
}

export function UpdateJournalSupportRequestFromJSON(json: any): UpdateJournalSupportRequest {
    return UpdateJournalSupportRequestFromJSONTyped(json, false);
}

export function UpdateJournalSupportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateJournalSupportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'endTimeUtc': (new Date(json['endTimeUtc'])),
    };
}

export function UpdateJournalSupportRequestToJSON(json: any): UpdateJournalSupportRequest {
    return UpdateJournalSupportRequestToJSONTyped(json, false);
}

export function UpdateJournalSupportRequestToJSONTyped(value?: UpdateJournalSupportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endTimeUtc': value['endTimeUtc'].toISOString(),
    };
}

